
import { call, put, takeLatest } from 'redux-saga/effects';
import hanldeException from '../services/handleException';
import { CHECK_POSTAL_CODE, CHECK_POSTAL_CODE_FAILS, CHECK_POSTAL_CODE_SUCCESS } from './../actions/addOrder';
import { CHECK_POSTAL_CODE_EDIT_ORDER, CHECK_POSTAL_CODE_EDIT_ORDER_FAILS, CHECK_POSTAL_CODE_EDIT_ORDER_SUCCESS } from './../actions/editOrder';
import lang from './../languages/en';
import { alertWarning } from './../services/dialog';
import { checkPostalCode } from './../utils/orders';

export function* checkPostalCodeSaga() {
    yield takeLatest(CHECK_POSTAL_CODE, checkPostalCodeHandle)
}

function* checkPostalCodeHandle(action) {
    try {
        const response = yield call(checkPostalCode, action.payload)

        if (response.data.code === 10001) {
            if (!response.data.data) {
                alertWarning(lang.postal_code_exist)
            }
            yield put({ type: CHECK_POSTAL_CODE_SUCCESS, payload: response })
        } else {
            yield put({ type: CHECK_POSTAL_CODE_FAILS, payload: response })
            hanldeException(response)
        }
    } catch (error) {
        yield put({ type: CHECK_POSTAL_CODE_FAILS, payload: error })
        hanldeException(error)
    }
}

export function* checkPostalCodeEditOrderSaga() {
    yield takeLatest(CHECK_POSTAL_CODE_EDIT_ORDER, checkPostalCodeEditOrderHandle)
}

function* checkPostalCodeEditOrderHandle(action) {
    try {
        const response = yield call(checkPostalCode, action.payload)

        if (response.data.code === 10001) {
            if (!response.data.data) {
                alertWarning(lang.postal_code_exist)
            }
            yield put({ type: CHECK_POSTAL_CODE_EDIT_ORDER_SUCCESS, payload: response })
        } else {
            yield put({ type: CHECK_POSTAL_CODE_EDIT_ORDER_FAILS, payload: response })
            hanldeException(response)
        }
    } catch (error) {
        yield put({ type: CHECK_POSTAL_CODE_EDIT_ORDER_FAILS, payload: error })
        hanldeException(error)
    }
}




// WEBPACK FOOTER //
// ./src/sagas/checkPostalCodeSaga.js